
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 56 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M12.618 45.51c-.154 0-.308 0-.464-.013h-10.4a1.75 1.75 0 010-3.5h10.5a4.945 4.945 0 005.25-4.532V29.75a1.75 1.75 0 013.5 0v7.885a8.422 8.422 0 01-8.386 7.875z"}}),_c('path',{staticClass:"a",attrs:{"d":"M1.75 49A1.75 1.75 0 010 47.25V38.5a1.75 1.75 0 013.5 0v8.75A1.75 1.75 0 011.75 49zM35 24.5H3.5A3.5 3.5 0 010 21v-8.75A12.263 12.263 0 0112.25 0h38.5A5.255 5.255 0 0156 5.25v2.975a5.255 5.255 0 01-3.118 4.8L40.25 18.639v.611A5.256 5.256 0 0135 24.5zm-22.75-21a8.76 8.76 0 00-8.75 8.75V21H35a1.753 1.753 0 001.75-1.75v-1.748a1.75 1.75 0 011.039-1.6L51.46 9.825a1.753 1.753 0 001.04-1.6V5.25a1.752 1.752 0 00-1.75-1.75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M43.75 31.5h-31.5a8.76 8.76 0 01-8.75-8.75 1.75 1.75 0 013.5 0A5.256 5.256 0 0012.25 28h31.5a1.752 1.752 0 001.75-1.75V13.612a1.75 1.75 0 013.5 0V26.25a5.256 5.256 0 01-5.25 5.25zm10.5-5.251A1.749 1.749 0 0152.5 24.5v-7a1.75 1.75 0 013.5 0v7a1.749 1.749 0 01-1.75 1.749z"}})])
          )
        }
      }
    